import { render, staticRenderFns } from "./allPeople.vue?vue&type=template&id=0dcf1a4f&scoped=true"
import script from "./allPeople.vue?vue&type=script&lang=js"
export * from "./allPeople.vue?vue&type=script&lang=js"
import style0 from "./allPeople.vue?vue&type=style&index=0&id=0dcf1a4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcf1a4f",
  null
  
)

export default component.exports